import { formatDateBySeries } from '~/helpers/dateHelper'

import { AnalyticsQuery } from '@hap/analytics'

interface TimeSeriesData {
  time: string
  placeholder: number
}

export function createPlaceholderData(
  timespan: { start: string | Date; end: string | Date },
  series: AnalyticsQuery['series'],
) {
  const end = new Date(timespan.end)
  const data: TimeSeriesData[] = []
  const currentDate = new Date(timespan.start)

  while (currentDate <= end) {
    data.push({
      time: formatDateBySeries(currentDate.toISOString(), series),
      placeholder: 0,
    })

    switch (series) {
      case 'hour':
        currentDate.setHours(currentDate.getHours() + 1)
        break
      case 'day':
        currentDate.setDate(currentDate.getDate() + 1)
        break
      case 'week':
        currentDate.setDate(currentDate.getDate() + 6)
        break
      case 'month':
        currentDate.setMonth(currentDate.getMonth() + 1)
        break
      case 'year':
        currentDate.setFullYear(currentDate.getFullYear() + 1)
        break
      default:
        throw new Error('Invalid series type')
    }
  }

  return data
}
